import type { FC } from "react";

import classNames from "classnames";

import {
  groupValuesByLabel,
  truncateValues,
  useMaxProductCharactersLength,
  VALUES_SEPARATOR,
  type ValueWithLabel,
} from "../utils";

import styles from "./StoreLocatorProductAttributeValues.module.scss";

type StoreLocatorStickAttributeValuesProps = {
  values: ValueWithLabel[];
  isListView: boolean;
};

export const StoreLocatorStickAttributeValues: FC<StoreLocatorStickAttributeValuesProps> = ({ values, isListView }) => {
  const maxProductCharactersLength = useMaxProductCharactersLength();
  const isGrouped = values.some((item) => item.label);
  const groupedByLabel = groupValuesByLabel(values);

  const renderGroupedValues = () => {
    return Object.entries(groupedByLabel).map(([label, groupValues]) => {
      const { displayedValues, restCount } = truncateValues(groupValues, isListView, maxProductCharactersLength, label);
      const result = displayedValues.join(VALUES_SEPARATOR);

      return (
        <div className={styles.productAttributeValues} key={label}>
          <div>
            {label && <span className={styles.productSticksLabel}>{label}: </span>}
            <span>{result}</span>
          </div>
          {restCount > 0 && (
            <span className={styles.productAttributeValuesCount} data-testid="attributeValuesCount">
              +{restCount}
            </span>
          )}
        </div>
      );
    });
  };

  return (
    <div
      className={classNames({
        [styles.productAttributeValuesGrouped]: isGrouped,
      })}
      data-testid="storeLocatorAttributeValues"
    >
      {renderGroupedValues()}
    </div>
  );
};
